import { RequestStatus } from 'clickNgo/configs/service/common'

import { ICommitmentItemsState, ICommitmentState, ICommitmentStatusesState } from './models/state'

const commitmentItemsInitialState: ICommitmentItemsState = {
  data: [],
  status: RequestStatus.FULFILLED,
  message: '',
}

const commitmentStatusesInitialState: ICommitmentStatusesState = {
  data: [],
  status: RequestStatus.FULFILLED,
  message: '',
}

export const initialState: ICommitmentState = {
  commitmentItems: commitmentItemsInitialState,
  commitmentStatuses: commitmentStatusesInitialState,
}
